import { styled } from '@mui/material';
import { ReactNode } from 'react';

export type RoundIconProps = {
  icon: ReactNode;
};

const StyledRoundIcon = styled('div')({
  width: 48,
  height: 48,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  background: 'var(--info-info-background-color)',
  svg: {
    fill: 'var(--color-blue-500)',
  },
});

export const RoundIcon = ({ icon }: RoundIconProps) => {
  return <StyledRoundIcon>{icon}</StyledRoundIcon>;
};
